"use client";

import { Text } from "@chakra-ui/react";
import { PROFILE_SHAPING_LABELS } from "@/features/profile-shaping";
import { Target } from "@/generated/fastapi";
import GenericSelector from "@/shared/ui/controls/GenericSelector";
import type { GenericOptionItem } from "@/shared/ui/controls/option.types";
import QueryChips from "./QueryChips";

interface SearchTargetFocusSectionProps {
  targetsToRerank: Target[];
  targetItems: GenericOptionItem[];
  targetSourceItems: Target[];
  isLoading: boolean;
  onTargetsChange: (targets: Target[]) => void;
}

export default function SearchTargetFocusSection({
  targetsToRerank,
  targetItems,
  targetSourceItems,
  isLoading,
  onTargetsChange,
}: SearchTargetFocusSectionProps) {
  return (
    <>
      <Text fontSize="sm">{PROFILE_SHAPING_LABELS.profileFocus}</Text>
      <GenericSelector<Target>
        previewItems={targetItems}
        stateObject={targetsToRerank}
        stateObjectSetter={onTargetsChange}
        sourceItems={targetSourceItems}
        mode="select"
        placeholder={PROFILE_SHAPING_LABELS.chooseFocus}
        isLoading={isLoading}
      />
      <QueryChips />
    </>
  );
}
